import ContentAssetCustom from "@components/BasicComponents/ContentAsset/ContentAssetCustomPricing/ContentAssetCustom"
import PricingSlider from "@components/BasicComponents/PricingSlider/PricingSlider"
import Separator from "@components/CustomTypography/Separator/Separator"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import OnePricingSection from "../OnePricingSection/OnePricingSection"

type Props = {
	data?: AdvancedSideAssetMainContent
	dataPricing: AdvancedSideAssetModuleType
}

const WebstoreOneSection = (props: Props) => {
	return (
		<>
			<ContentAssetCustom
				customModule={
					<div
						style={{
							margin: "0 auto",
							position: "relative",
						}}
					>
						<PricingSlider />
					</div>
				}
				data={props.data}
				direction={"left"}
			/>
			<Separator size={128} />

			<OnePricingSection data={props.dataPricing} />
			<Separator size={128} />
		</>
	)
}

export default WebstoreOneSection
